import {
  DateRangeFilterDefinition,
  FilterDateConfig,
  FilterNumberConfig,
  FilterStringConfig,
  MultiSelectBooleanFilterDefinition,
  MultiSelectDateFilterDefinition,
  MultiSelectStringFilterDefinition,
  NumberRangeFilterDefinition,
  SearchStringFilterDefinition,
  SingleSelectBooleanFilterDefinition,
  SingleSelectDateFilterDefinition,
  SingleSelectStringFilterDefinition,
} from '@asset-metrix/portal-gateway-client-js';
import { isObject } from '@asset-metrix/portal-ui';

export type SingleSelectFilterData =
  | (SingleSelectDateFilterDefinition & { display: 'single-date-picker' })
  | ((
      | SingleSelectDateFilterDefinition
      | SingleSelectStringFilterDefinition
      | SingleSelectBooleanFilterDefinition
    ) & {
      display: 'single-select';
    });

export type MultiSelectFilterData = (
  | MultiSelectDateFilterDefinition
  | MultiSelectStringFilterDefinition
  | MultiSelectBooleanFilterDefinition
) & {
  display: 'multi-select';
};

export type DateRangeFilterData = DateRangeFilterDefinition & {
  display: 'range-date-picker';
};

export type NumberRangeFilterData = NumberRangeFilterDefinition & {
  display: 'range-number-picker';
};

export type SearchFilterData = SearchStringFilterDefinition & {
  display: 'search';
};

export type FilterData =
  | SingleSelectFilterData
  | MultiSelectFilterData
  | DateRangeFilterData
  | NumberRangeFilterData
  | SearchFilterData;

type SingleSelectDefinitions =
  | SingleSelectDateFilterDefinition
  | SingleSelectStringFilterDefinition
  | SingleSelectBooleanFilterDefinition;

type MultiSelectDefinitions =
  | MultiSelectDateFilterDefinition
  | MultiSelectStringFilterDefinition
  | MultiSelectBooleanFilterDefinition;

type FilterDefinitions =
  | SingleSelectDefinitions
  | MultiSelectDefinitions
  | DateRangeFilterDefinition
  | NumberRangeFilterDefinition
  | SearchStringFilterDefinition;

export type FilterConfigDto =
  | FilterDateConfig
  | FilterStringConfig
  | FilterNumberConfig;

export const isDateRangeFilter = (
  filter: FilterDefinitions
): filter is DateRangeFilterDefinition =>
  isObject(filter) &&
  filter.type === 'date' &&
  (filter.selection == null || isObject(filter.selection));

export const isNumberRangeFilter = (
  filter: FilterDefinitions
): filter is NumberRangeFilterDefinition =>
  isObject(filter) &&
  filter.type === 'number' &&
  (filter.selection == null || isObject(filter.selection));

export const isMultiSelectFilter = (
  data: FilterDefinitions
): data is MultiSelectDefinitions =>
  data.selection == null || Array.isArray(data.selection);

export const isSingleSelectFilter = (
  data: FilterDefinitions
): data is SingleSelectDefinitions =>
  data.selection == null || !Array.isArray(data.selection);

export const isSearchStringFilter = (
  data: FilterDefinitions
): data is SearchStringFilterDefinition =>
  (data.selection == null || typeof data.selection === 'string') &&
  data.type === 'text';

export type Filter = Partial<{
  [key: string]: FilterData;
}>;
